module.exports = __webpack_public_path__ + "static/img/step2.0604ed5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pages/task/step2.png
// module id = VBxX
// module chunks = 30